export function localPackUrl(url: string) {
  if (url !== 'https://jerpg.com/assets/jerpg-pack-legacy.zip') throw new Error('Unsupported JERPG resource pack URL')
  return '/jerpg-pack/pack.zip'
}
export async function installRequiredPack(packet: {url: string, hash: string, uuid?: string}, write: (name: string, data: any) => void, install: (url: string, hash: string) => Promise<void>) {
  const identity = packet.uuid ? {uuid: packet.uuid} : {}
  const status = (result: number) => write('resource_pack_receive', {...identity, result})
  try {
    const url = localPackUrl(packet.url)
    if (!/^[a-f\d]{40}$/i.test(packet.hash)) throw new Error('Missing or invalid resource pack SHA-1')
    status(3)
    await install(url, packet.hash.toLowerCase())
    status(0)
  } catch (error) { status(2); throw error }
}
